export default __webpack_public_path__ + "static/media/SentricsLogoPng.c979c609.png";